var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3835 19.2341L6.33924 23.2624L2.5225 23.3458C1.38186 21.1596 0.734863 18.6584 0.734863 16.0004C0.734863 13.4301 1.33979 11.0063 2.41205 8.87207H2.41287L5.81084 9.5158L7.29936 13.006C6.98781 13.9445 6.81801 14.952 6.81801 16.0004C6.81813 17.1382 7.01758 18.2283 7.3835 19.2341Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4728 13.1045C30.6451 14.0421 30.7349 15.0104 30.7349 16.0001C30.7349 17.1098 30.622 18.1922 30.4069 19.2364C29.6767 22.7894 27.7687 25.892 25.1256 28.0875L25.1248 28.0867L20.8449 27.861L20.2392 23.9536C21.993 22.8908 23.3636 21.2275 24.0856 19.2364H16.0647V13.1045H24.2026H30.4728Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1246 28.0863L25.1255 28.0871C22.5549 30.2222 19.2895 31.4997 15.7348 31.4997C10.0225 31.4997 5.056 28.2004 2.52246 23.3451L7.38346 19.2334C8.65019 22.7268 11.9115 25.2137 15.7348 25.2137C17.3782 25.2137 18.9178 24.7546 20.2389 23.9532L25.1246 28.0863Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3094 4.06839L20.45 8.17928C19.0827 7.29614 17.4665 6.78598 15.7349 6.78598C11.825 6.78598 8.50275 9.38689 7.29947 13.0056L2.41293 8.8717H2.41211C4.90855 3.89807 9.93766 0.5 15.7349 0.5C19.3745 0.5 22.7116 1.83966 25.3094 4.06839Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_1974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31,
    fill: "white",
    transform: "translate(0.734863 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.44a214a70c0688fefc846a5d2a1217cb.svg";
export { ForwardRef as ReactComponent };